module.exports = __webpack_public_path__ + "icon-close-light.svg?f3dcc57b21f7f21f4168f79eae3805cf";